// extracted by mini-css-extract-plugin
module.exports = {"ContactTopInfo":"ContactTopInfo_ContactTopInfo__1z3TC","Wrap":"ContactTopInfo_Wrap__1i6dM"};